import { redirect } from "next/navigation";
export default function SecurityAuditRedirectPage() {
  redirect("/admin/profile?tab=audit");
}
